export const addItems = (data: any) => ({
  type: "ADD_ITEMS",
  payload: data,
});
export const setItems = (data: any) => ({
  type: "SET_ITEMS",
  payload: data,
});
export const removeItems = (data: any) => ({
  type: "REMOVE_ITEMS",
  payload: data,
});
export const setQtyItem = (data: any) => ({
  type: "SET_QTY_BY_ID",
  payload: data,
});
export const setDiscountItem = (data: any) => ({
  type: "SET_DISCOUNT_BY_ID",
  payload: data,
});
export const resetItem = (data: any) => ({
  type: "RESET_QTY_BY_ID",
  payload: data,
});
export const finalData = (data: any) => ({
  type: "FINAL_DATA",
  payload: data,
});
export const clearItem = () => ({
  type: "CLEAR",
});
export const card = (data: any) => ({
  type: "CARD",
  payload: data,
});
export const cash = (data: any) => ({
  type: "CASH",
  payload: data,
});
export const bank = (data: any) => ({
  type: "BANK",
  payload: data,
});
export const discount = (data: any) => ({
  type: "DISCOUNT",
  payload: data,
});
export const search = (data: any) => ({
  type: "SEARCH",
  payload: data,
});
export const customer = (data: any) => ({
  type: "CUSTOMER",
  payload: data,
});
export const customerName = (data: any) => ({
  type: "CUSTOMER_NAME",
  payload: data,
});

export const filterItemsBySearch = (
  query: string,
  items: { name: string; barcode?: string; itemNumber?: string }[]
) => {
  if (!query || !items?.length) return [];

  const searchTerm = query.toLowerCase().trim();

  return items.filter((item) => {
    // Check for matches in name
    if (item.name && item.name.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Check for matches in full barcode
    if (item.barcode && item.barcode.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Check for matches in item number
    if (item.itemNumber && item.itemNumber.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Check for last 4 digits of barcode or item number
    if (searchTerm.length >= 3) {
      if (item.barcode && item.barcode.endsWith(searchTerm)) {
        return true;
      }
      if (item.itemNumber && item.itemNumber.endsWith(searchTerm)) {
        return true;
      }
    }

    return false;
  });
};

export const barcode = (data: any) => ({
  type: "BARCODE",
  payload: data,
});
export const focusInput = (data: any) => ({
  type: "FOCUS_INPUT",
  payload: data,
});
export const inputKeyboardName = (data: any) => ({
  type: "INPUT_KEYBOARD_NAME",
  payload: data,
});
export const cashOutOpen = (data: any) => ({
  type: "CASH_OUT_OPEN",
  payload: data,
});
export const cashinOpen = (data: any) => ({
  type: "CASH_IN_OPEN",
  payload: data,
});
export const cashinClose = (data: any) => ({
  type: "CASH_IN_CLOSE",
  payload: data,
});
export const numberInput = (data: any) => ({
  type: "NUMBER_INPUT",
  payload: data,
});
export const numberInputClear = () => ({
  type: "NUMBER_INPUT_CLEAR",
});
export const backSpace = () => ({
  type: "BACK_SPACE",
});
export const hold = () => ({
  type: "HOLD",
});
export const enter = () => ({
  type: "ENTER",
});
export const cashInOut = (data: any) => ({
  type: "CASH_IN_OUT",
  payload: data,
});
export const focusInputCash = (data: any) => ({
  type: "FOCUS_INPUT_CASH",
  payload: data,
});
export const itemData = (data: any) => ({
  type: "ITEM_DATA",
  payload: data,
});
export const filteredItemData = (data: any) => ({
  type: "FILTERED_ITEM_DATA",
  payload: data,
});
export const removeFilteredItemData = (data: any) => ({
  type: "REMOVE_FILTERED_ITEM_DATA",
  payload: data,
});
export const categoryData = (data: any) => ({
  type: "CATEGORY_DATA",
  payload: data,
});
export const customerData = (data: any) => ({
  type: "CUSTOMER_DATA",
  payload: data,
});
